module.exports = __webpack_public_path__ + "img/ring_g_c_1_0.7762cc92.png";